import axios from 'axios'

export default {
  namespaced: true,

  state: () => ({
    customers: [],
    themes: [],
    loading: false,
  }),

  getters: {
    customers: state => state.customers,
    themes: state => state.themes,
    loading: state => state.loading,
  },

  mutations: {
    SET_CUSTOMERS(state, customers) {
      state.customers = customers
    },
    SET_THEMES(state, themes) {
      state.themes = themes
    },
    SET_LOADING(state, status) {
      state.loading = status
    },
  },

  actions: {
    /**
     * Fetch customer list (with optional regionId)
     */
    async fetchCustomers({ commit }, regionId = null) {
      commit('SET_LOADING', true)
      try {
        const params = {}
        if (regionId) params.regionId = regionId

        const { data } = await axios.get('/customers', { params })
        commit('SET_CUSTOMERS', data)
      } catch (error) {
        console.error('Error fetching customers:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    /**
     * Fetch themes for a specific customer
     */
    async fetchThemesByCustomer({ commit }, customerId) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`/customers/${customerId}/themes`)
        commit('SET_THEMES', data)
      } catch (error) {
        console.error(`Error fetching themes for customer ${customerId}:`, error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },
}